module.exports = __webpack_public_path__ + "static/media/social7.f7a22cac.png";